import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axiosConfig"; // Connect to Backend
import { toast } from "react-toastify";
// 🟢 NEW: Import Auth Context
import { useAuth } from "./AuthContext";

const DailyLogContext = createContext();

export const DailyLogProvider = ({ children }) => {
  const [logs, setLogs] = useState([]);
  
  // 🟢 NEW: Get the current user
  const { user } = useAuth();

  // 1. FETCH
  const fetchLogs = async () => {
    try {
      const res = await api.get("/dailylogs");
      setLogs(res.data);
    } catch (err) {
      console.error("Error fetching logs:", err);
    }
  };

  // 🟢 FIX: Only fetch if user is logged in
  useEffect(() => {
    if (user && user.id) {
      fetchLogs();
    } else {
      setLogs([]);
    }
  }, [user]);

  const getProjectLogs = (projectId) => logs.filter(l => String(l.projectId) === String(projectId));

  // 2. CREATE LOG (Draft)
  const saveDailyLogDraft = async (logData) => {
    try {
      const res = await api.post("/dailylogs", { ...logData, status: 'Draft' });
      await fetchLogs();
      return res.data; // Return saved log
    } catch (err) {
      console.error("Error saving draft:", err);
      toast.error("Failed to save draft");
    }
  };

  // 3. SUBMIT LOG
  const submitDailyLog = async (logId) => {
    try {
      // Typically updates status to 'Submitted'
      await api.put(`/dailylogs/${logId}`, { status: 'Submitted' });
      
      // Ideally, trigger inventory deduction here via another API call or backend logic
      
      await fetchLogs();
      return { success: true, message: "Daily Log Submitted" };
    } catch (err) {
      return { success: false, message: "Submission Failed" };
    }
  };

  const weatherOptions = ["Sunny", "Cloudy", "Rainy", "Windy", "Stormy"];

  return (
    <DailyLogContext.Provider value={{ logs, getProjectLogs, saveDailyLogDraft, submitDailyLog, weatherOptions }}>
      {children}
    </DailyLogContext.Provider>
  );
};

export const useDailyLogs = () => useContext(DailyLogContext);